import { createAction } from 'redux-actions';
import { Map as ImmutableMap } from 'immutable';

import { rootUiActions, rootUiTypes } from 'companion-app-components/flux/root-ui';

export const DIALOG_TYPE = 'WF_BUDGET_SETUP_ACTION';

export const doWFBudgetSetup = createAction(
  rootUiActions.createDialog.toString(),
  (id) => rootUiTypes.mkRootUiData({
    type: DIALOG_TYPE,
    allowNesting: true,
    props: ImmutableMap({
      id,
      title: '',
    }),
  }),
);
